/**
 * Supabase client singleton
 * Используется во всём приложении для работы с БД
 *
 * URL и anon key берутся из env переменных — не хардкодим в коде:
 *   - можно легко менять окружение (staging/prod/personal dev)
 *   - ротация ключа не требует коммита
 *   - публичные ссылки на репо не светят конкретный проект
 *
 * Хотя anon key безопасен (защищён RLS), выделение в env — индустриальный
 * стандарт для production-grade приложений.
 */

import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// Читаем из env. Vite пробрасывает только VITE_*-префиксированные переменные
// в клиентский бандл (это стандарт безопасности Vite, не опция).
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail-fast при отсутствии: лучше упасть на старте с понятной ошибкой,
// чем получить странные 401-ы в рантайме. Типичная причина — забыли создать
// .env.local локально или настроить env vars в Vercel для нового окружения.
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Отсутствуют обязательные переменные окружения: VITE_SUPABASE_URL и/или VITE_SUPABASE_ANON_KEY. ' +
    'Проверь .env.local (локально) или Project Settings → Environment Variables в Vercel (деплой).',
  );
}

/** URL проекта Supabase — реэкспорт для использования в serverClient */
export { supabaseUrl as SUPABASE_URL };

/** Публичный anon key — реэкспорт для использования в serverClient */
export { supabaseAnonKey as SUPABASE_ANON_KEY };

// Создаём клиент с типизацией
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);